var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.886 89.6802C177.886 138.657 138.355 178.361 89.5896 178.361C40.8246 178.361 1.29285 138.657 1.29285 89.6802C1.29285 40.7032 40.8246 0.999512 89.5896 0.999512C138.355 0.999512 177.886 40.7032 177.886 89.6802ZM14.5374 89.6802C14.5374 131.311 48.1394 165.059 89.5896 165.059C131.04 165.059 164.642 131.311 164.642 89.6802C164.642 48.0497 131.04 14.3016 89.5896 14.3016C48.1394 14.3016 14.5374 48.0497 14.5374 89.6802Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.baa1f35b863c8c54e908cc22f6d9fbb5.svg";
export { ForwardRef as ReactComponent };